/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Image from "react-bootstrap/Image";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-bootstrap/Carousel";

/* Helpers, constants, custom methods, internal libraries */
import { useUserService } from "../../../services/userService";

/* Components */
import UCButton from "../../buttons";
import mockImage from "../../../resources/images/wallet_modal_trip_credits.webp"

/* Styles */
import styles from "./styles.js"

//todo add carousel data when available
const carouselData = [
  {
    image: mockImage,
    title: <FormattedMessage id="travelCreditsWelcomeModal.carousel.title"/>, 
    description: <FormattedMessage id="travelCreditsWelcomeModal.carousel.description"/>
  },
  {
    image: mockImage,
    title: <FormattedMessage id="travelCreditsWelcomeModal.carousel.title2" />,
    description: <FormattedMessage id="travelCreditsWelcomeModal.carousel.description2" values={{ br: <br /> }} />,
  },
  {
    image: mockImage,
    title: <FormattedMessage id="travelCreditsWelcomeModal.carousel.title3"/>, 
    description: <FormattedMessage id="travelCreditsWelcomeModal.carousel.description3"/>
  },
]


const Content = props => {
  const { setShowModal } = props;
  const theme = useTheme();
  const classes = styles({ theme });

  const { getUserDetails } = useUserService();
  const [index, setIndex] = useState(0);

  const handleSelectCarouselSlide = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const handleNext = () => {
    if (index === 2) {
      handleCloseModal()
    } else {
      setIndex(index + 1)
    }
  }
  const handleCloseModal = async () => {
    setShowModal(false)
    await getUserDetails();
  }

  return (
    <div className={classes.modalContent}>
      <Carousel
          className={classes.carouselContainer}
          activeIndex={index}
          onSelect={ handleSelectCarouselSlide }
          interval={null}
          controls={false}
        >
          {carouselData.map((item, index) => 
             (
              <Carousel.Item key={index} className={classes.carouselSlide}>
                <Col className={classes.citiBanner}>
                  <Image className={classes.carouselImage} src={ item.image } />
                  <div className={classes.carouselTitle}>{item.title}</div>
                  <div className={classes.carouselDescription}>{item.description}</div>
                </Col>
              </Carousel.Item>
            )
          )}
      </Carousel>

      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            {index !== 2 && (
              <Col className={classes.colSkip}>
              <UCButton
                onClick={ handleCloseModal }
                type="default"
                className={classes.skipBtn}
                text={<FormattedMessage id="travelCreditsWelcomeModal.skip"/>}
              />
            </Col>
            )}
            <Col className={classes.colNext} >
              <UCButton
                className={classes.nextBtn}
                onClick={ handleNext }
                type="primary"
                text={index === 2 ? <FormattedMessage id="travelCreditsWelcomeModal.getStarted"/> : <FormattedMessage id="travelCreditsWelcomeModal.next"/>}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default Content;